import { render, staticRenderFns } from "./ModuleCopy.vue?vue&type=template&id=0c61ecf7&"
import script from "./ModuleCopy.vue?vue&type=script&lang=js&"
export * from "./ModuleCopy.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCopy.vue?vue&type=style&index=0&id=0c61ecf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports